import axios from "@/services/axios.config";
import type { CreditTransferListWithPagination } from "@/types/creditTracking";
import { toastOnError } from "@/utils/toastOnError";
import { useQuery } from "@tanstack/react-query";

const fetchCreditTransferListForRegistry = async (
	limit: number,
	offset: number,
): Promise<CreditTransferListWithPagination> =>
	axios
		.get<APIResponse<CreditTransferListWithPagination>>("/credit/transfer/list/public", {
			params: { limit, offset },
		})
		.then((res) => res.data.data ?? { limit: String(limit), offset: String(offset), count: 0, data: [] })
		.catch((err) => Promise.reject(err.response?.data as APIResponse));

export default function useGetCreditTransferListForRegistry(limit: number, offset: number) {
	return useQuery({
		queryKey: ["getCreditTransferListForRegistry", limit, offset],
		queryFn: () => fetchCreditTransferListForRegistry(limit, offset),
		onError: (err: APIResponse) => {
			if (![400, 403, 404].includes(err.httpStatus)) {
				toastOnError(err);
			}
		},
	});
}
